import React, { useEffect, useState } from 'react';

const easeOutQuad = (t) => 1 - (1 - t) * (1 - t);

const StatCounter = ({ target, duration = 2000, start = false }) => {
  const [display, setDisplay] = useState(() => {
    const text = String(target);
    const match = text.match(/[\d.,]+/);
    const suffix = match ? text.replace(match[0], '') : '';
    return `0${suffix}`;
  });

  useEffect(() => {
    if (!start) return;

    const text = String(target);
    const match = text.match(/[\d.,]+/);
    const numeric = match ? parseFloat(match[0].replace(/,/g, '')) : 0;
    const suffix = match ? text.replace(match[0], '') : '';

    let frameId;
    const startTime = performance.now();

    const animate = (now) => {
      const elapsed = now - startTime;
      const t = Math.min(elapsed / duration, 1);
      const eased = easeOutQuad(t);
      const value = Math.round(numeric * eased);

      if (elapsed < duration) {
        setDisplay(`${value}${suffix}`);
        frameId = requestAnimationFrame(animate);
      } else {
        setDisplay(`${numeric}${suffix}`);
      }
    };

    frameId = requestAnimationFrame(animate);

    return () => {
      if (frameId) cancelAnimationFrame(frameId);
    };
  }, [start, target, duration]);

  return <span>{display}</span>;
};

export default StatCounter;

